import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\">\n<circle cx=\"16\" cy=\"16\" r=\"13\" fill=\"#8998C3\" />\n<path d=\"M12.7975 13.6904H17.8452C19.5875 13.6904 21 15.1029 21 16.8452V16.8452C21 18.5876 19.5875 20.0001 17.8452 20.0001H13.4284\" stroke=\"white\" stroke-width=\"1.5\" />\n<path d=\"M14.6905 11.1666L12.1666 13.7913L14.6905 16.2143\" stroke=\"white\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol